import { Checkbox } from 'antd'
import './index.scss'

export default function BasicCheckBox({ className = '', children, ...props }) {
  const mergedClassName = ['BasicCheckBox', className].filter(Boolean).join(' ')

  return (
    <Checkbox {...props} className={mergedClassName}>
      <span className="BasicCheckBox_label">{children}</span>
    </Checkbox>
  )
}
